import type { User, UserWithPassword } from '@/types/User.ts'

export const getEmptyUserObject = (): User => {
    return structuredClone({
        id: '',
        firstname: '',
        lastname: '',
        email: '',
        language: ''
    })
}

export const getEmptyUserUserWithPasswordObject = (): UserWithPassword => {
    return structuredClone({
        id: '',
        firstname: '',
        lastname: '',
        email: '',
        language: '',
        password: ''
    })
}
